var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subAccountCommonDialog',{attrs:{"visible":_vm.visible,"title":"提示"},on:{"update:visible":function($event){_vm.visible=$event},"clickCancel":_vm.clickCancel,"clickConfirm":_vm.clickConfirm},scopedSlots:_vm._u([{key:"dialogContent",fn:function(){return [_vm._v("删除账号操作会删除发布在此账号中的所有作品，是否确定删除？ ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }